<template>
    <div v-if="display">
        <div class="container header-margin">

            <div class="text-center p-2 text-color text-area">
                <h2 class="main_title">{{ $t('aube_quest.registration.title') }}</h2>
            </div>

            <div class="info-box">
                <small class="text-muted">{{ $t('aube_quest.registration.title_quest_info') }}</small>
                <div>Quest ID: {{ formData.quest_id }}</div>
                <div>Connector ID: {{ formData.connectorMemberId }}</div>
                <div>{{ $t('aube_quest.connector_start_date') }}: {{ formData.joinedDate }}</div>
                <div v-if="errors.quest_id" class="error-message">{{ errors.quest_id ? $t('errors.' + errors.quest_id) : '' }}</div>
            </div>

            <div v-if="errors.timeOverToken">
                <!-- トークンデータ24時間超過 -->
                <div class="show-check-email-message" v-html="$t('aube_quest.registration.tokenRegistrationTimeOverText')"></div><br />
                <div class="text-center">
                    <div class="pb-4 ">
                        <a class="btn btn-primary text-center-btn" href="https://www.force-club.com/login" role="button">{{$t('auth.changeEmail.buttom') }}</a>
                    </div>
                </div>
            </div>
            <div v-if="errors.notLatestToken">
                <!-- 最新ではないトークンデータ -->
                <div class="show-check-email-message" v-html="$t('auth.notLatestTokenText')"></div><br />
                <div class="text-center">
                    <div class="pb-4 ">
                        <a class="btn btn-primary text-center-btn" href="https://www.force-club.com/login" role="button">{{$t('auth.changeEmail.buttom') }}</a>
                    </div>
                </div>
            </div>
            <div v-if="errors.notExistToken">
                <!-- トークンデータが存在しない -->
                <div class="text-center p-2">
                    {{ $t('auth.notExistTokenText') }}
                </div><br />
                <div class="text-center">
                    <div class="pb-4 ">
                        <a class="btn btn-primary text-center-btn" href="https://www.force-club.com/login" role="button">{{$t('auth.changeEmail.buttom') }}</a>
                    </div>
                </div>
            </div>

            <div v-if="success === true">
                <div class="tab-content p-2" >
                    <div class="row no-gutters text-center navigation">
                        <div id="box1" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title1') }}</p></div>
                        <div id="box2" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title2') }}</p></div>
                        <div id="box3" class="col-md-3 col-sm-3 col-xs-5 box-area active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title3') }}</p></div>
                        <div id="box4" class="col-md-3 col-sm-3 col-xs-5 box-area non-active-color-box"><p class="text-box">{{ $t('auth.navigationForceclub.title4') }}</p></div>
                    </div>

                    <div class="mx-auto" >
                        <div class="text-center p-2">
                            <h3 class="text-color sub_title">{{ $t('aube_quest.confirm.title') }}</h3>
                        </div>

                        <form @submit.prevent="handleOnSubmit">
                            <div class="wrap-value">

                                <div>
                                    <label style="margin-bottom:10px;">{{ $t('aube_quest.confirm.text_confirm') }}</label>
                                </div>

                                <div class="form-group row">
                                    <label for="emailAube" class="col-sm-3 col-lg-2 col-form-label pre">{{ $t('aube_quest.registration.email_qId') }}</label>
                                    <div class="col-sm-8 col-form-value">
                                        {{formData.account ? formData.account : '-'}}
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label  for="first_name" class="col-sm-3 col-lg-2 col-form-label pre">{{ $t('aube_quest.registration.first_name') }}</label>
                                    <div class="col-sm-8 col-form-value">
                                        {{formData.first_name ? formData.first_name : '-'}}
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label  for="last_name" class="col-sm-3 col-lg-2 col-form-label pre">{{ $t('aube_quest.registration.last_name') }}</label>
                                    <div class="col-sm-8 col-form-value">
                                        {{formData.last_name ? formData.last_name : '-'}}
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label  for="password_conversion" class="col-sm-3 col-lg-2 col-form-label pre">{{ $t('aube_quest.registration.password') }}</label>
                                    <div class="col-sm-8 col-form-value">
                                        {{formData.password_conversion ? formData.password_conversion : '-'}}
                                    </div>
                                </div>


                                <div class="form-group row">
                                    <label  for="birth_date" class="col-sm-3 col-lg-2 col-form-label pre">{{ $t('account.edit.birthDate') }}</label>
                                    <div class="col-sm-8 col-form-value">
                                        {{formData.birth_date ? formData.birth_date : '-'}}
                                    </div>
                                </div>

                            </div>

                            <div class="text-center">
                                <table class="table text-center">
                                    <tbody>
                                        <tr>
                                            <th class="back_btn">
                                                <button type="button"  class="btn btn-outline-primary" @click="back">{{ $t('aube_quest.btn_edit') }}</button>
                                            </th>
                                            <th class="submit_btn" style="margin-left: 29px;">
                                                <button type="button" @click="handleOnSubmit" class="btn btn-primary mr-2" :disabled="submitBtnDisabled()">{{ $t('aube_quest.btn_register') }}</button>
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from '../../../../services/UserService';
    import QuestService from '../../../../services/QuestService';
    import languageService from "../../../../services/LanguageService";
    import RecaptchaMixin from '../../../../utils/RecaptchaMixin';
    import questService from "../../../../services/QuestService";

    export default {
        name: 'registration-module',
        mixins: [RecaptchaMixin],
        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
                display: false,
            }
        },
        created() {
            this.getConfirmData();
            this.token = this.$route.query.token;
            this.fetchQuestIdData(this.token);
            this.fetchUserData(this.token);
        },
        mounted() {
            this.maxHeight();
        },
        methods: {
            back: function(event){
            this.$router.push({
                path: '/registration-quest/continue',
                query: {
                        token: this.token
                    }
                })
            },
            getDefaultFields() {
                return {
                    first_name: '',
                    last_name: '',
                    birth_date: '',
                    password: '',
                    password_confirmation: '',
                    timeOverToken: '',
                    notLatestToken: '',
                    notExistToken: '',
                    success: false,
                    quest_id: '',
                    connectorMemberId: '',
                    joinedDate: '',
                };
            },
            submitBtnDisabled() {
                return this.formData.first_name == '' ||
                    this.formData.last_name == '' ||
                    this.formData.birth_date == '' ||
                    this.formData.password == '';
            },
            async handleOnSubmit() {
                this.errors = this.getDefaultFields();
                const languageCode = await languageService.getCurrentLanguageCode();
                const recaptchaToken = await this.recaptchaGetKey();
                try {
                    const result = await QuestService.registration({
                        token: this.formData.token,
                        languageCode: languageCode,
                        ...this.formData,
                        recaptchaToken
                    });

                    const { user, auth } = result.data;

                    if (user == null) {
                        alert(`${this.$t('aube_quest.verify_error.user_info_not_found')} ${this.formData.quest_id}`);

                        return;
                    }

                    if (auth) {
                        UserService.setLogin(auth);
                        this.$router.push({
                            path: '/registration-quest/complete',
                            query: {
                                token: this.formData.token
                            }
                        })
                    }

                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.field;
                                this.$router.push('/registration-quest/error?message=' + errItem.field+'&quest_id=' + this.formData.quest_id);
                            }
                        })
                    }
                    if (err.response.data.message) {
                        this.errors.quest_id = err.response.data.message;
                        await this.$router.push('/registration-quest/error?message=' + err.response.data.message + '&quest_id=' + this.formData.quest_id);
                    }
                }
            },
            async fetchQuestIdData(token) {
                const result = await UserService.getQuestIdByToken(token);

                this.formData.quest_id = result.data.quest_id || '';
                this.formData.token = token;
                if (!result.data.quest_id) {
                    this.errors.quest_id = this.$t('aube_quest.verify_error.quest_id_not_found');

                    return;
                }
                await this.getConnector(this.formData.quest_id);
            },
            async getConfirmData() {
                if (sessionStorage.formData) {
                    this.formData = JSON.parse(sessionStorage.formData);
                }
            },
            async fetchUserData(token) {
                this.errors = this.getDefaultFields();

                if(token == undefined && sessionStorage.formData){
                    token = JSON.parse(sessionStorage.formData).token;
                }
                try {
                    const result = await UserService.getUserAubeQuestConfirmDataByToken(token);
                    if (result.data.member_type_id == 2100 ||
                        result.data.member_type_id == 2200
                    ) {
                        this.$router.push('/');
                    } else {
                        this.display = true
                        this.maxHeight();
                    }
                    this.success = true
                } catch (err) {
                    this.display = true
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.field;
                            }
                        })
                    }
                }
            },
            async maxHeight() {
                setTimeout(() => {
                    let box1 = document.getElementById('box1').clientHeight
                    let box2 = document.getElementById('box2').clientHeight
                    let box3 = document.getElementById('box3').clientHeight
                    let box4 = document.getElementById('box4').clientHeight
                    let maxHeight = Math.max(box1,box2,box3,box4);
                    document.getElementById('box1').style.height = maxHeight+'px'
                    document.getElementById('box2').style.height = maxHeight+'px'
                    document.getElementById('box3').style.height = maxHeight+'px'
                    document.getElementById('box4').style.height = maxHeight+'px'
                }, 1000);
            },
            async getConnector (questId) {
                try {
                    const result = await questService.getConnectorByQuestId(questId);
                    this.formData.questId = result.data.quest_id;
                    this.formData.connectorMemberId = result.data.connector_id;
                    this.formData.joinedDate = result.data.joined_date;
                } catch (error) {
                }
            },
        }
    }
</script>

<style scoped>
    .main_title{
        margin-bottom:15px;
    }
    .sub_title{
        margin-bottom:15px;
    }
    .back_btn{
        text-align:right;
        font-weight:normal;
        width: 505px;
    }
    .submit_btn {
        text-align:left;
        font-weight:normal;
        width: 500px;
        padding-right: 0px;
    }
    .table th, .table th {
        border-top: 0px solid #dee2e6;
    }
    .table{
        position:relative;
    }
    .tos.form-control:disabled {
        background-color: white;
    }
    .pre {
        white-space: pre-wrap;
    }
    .active-color-box{
        background: #451493;
        border-color:#451493;
    }
    .non-active-color-box{
        background: #bdbebd;
    }
    .text{
        font-size: 25px;
    }
    .text-area{
        padding-bottom: 20px;
    }
    .box-area {
        padding: 0.5em 0em;
        width:50%;
        color: #FFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #box2,#box3,#box4{
        outline: 1px solid #FFF;
    }
    .box-area p {
        margin-top: 2px;
        margin-bottom: 2px;
        padding-top: 1px;
    }

    .header-margin{
        top:250px;
    }
    .navigation{
        padding-top:15px;
        padding-bottom:40px;
    }

    .text-color{
        color: #451493;
    }
   /* ボタンのスタイル指定 */
    .btn-primary{
        width: 115px;
    }

    .wrap-value{
        margin-left: 35px;
        margin-bottom: 10px;
    }

    .wrap-values{
        width:500px;
        margin-left: 35px;
    }

    .col-sm-8{
        padding-top:8px;
    }

    .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-primary.dropdown-toggle:focus {
        box-shadow: 0 0 0 0.2rem rgb(216 217 219 / 50%);
    }
    .btn-outline-primary:not(:disabled):not(.disabled):active:focus,
    .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-primary.dropdown-toggle:focus {
        box-shadow: 0 0 0 0.2rem rgb(216 217 219 / 50%);
    }
    .btn-outline-primary:not(:disabled):not(.disabled):active,
    .btn-outline-primary:not(:disabled):not(.disabled).active, .show >
    .btn-outline-primary.dropdown-toggle {
        color: #212529;
        background-color: #C4C4CC!important;
        border-color: #E2E6EA;
    }
    .btn-outline-primary:focus, .btn-outline-primary.focus {
        box-shadow: 0 0 0 0.2rem rgb(216 217 219 / 50%);
    }
    .btn-outline-primary {
        width: 115px;
        color: #212529;
        background-color: #E2E6EA;
        border-color:  #E2E6EA;
    }
    .btn-outline-primary:hover {
        color: #212529;
        background-color: #c4c4cc !important;
        border-color: #c4c4cc !important;
    }

    .info-box {
        background-color: #f7f7f7;
        border-radius: 6px;
        padding: 12px 16px;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #ebeaea;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
    .info-box small {
        display: block;
        color: #6c757d;
        margin-bottom: 4px;
        font-size: 0.85rem;
    }
    .info-box div {
        font-weight: 500;
        font-size: 0.95rem;
    }

    .error-message {
        display: block;
        margin-top: 0.25rem;
        font-size: 0.875rem;
        color: #e3342f;
        line-height: 1.4;
        word-wrap: break-word;
        max-width: 300px;
    }

    /*スマホ用css*/

    @media screen and (max-width: 479px) {

        .box-area[data-v-40212d93] {
            height: 90px;
        }
        .wrap-value{
            margin-left: 0px;
        }
        .wrap-values{
            width:500px;
            margin-left: 0px;
        }
        .col-form-label{
            padding-bottom: 0px;
        }
        .col-form-value{
            padding-top: 0px;
        }
        .header-margin{
            padding-left: 0px;
            padding-right: 0px;
        }
        .col-sm-8{
            padding-top:0px;
        }
        .main_title{
            font-size: 1.575rem;
            margin-bottom: 0px;
        }
        .sub_title{
            font-size: 1.3rem;
            margin-bottom: 10px;
        }
        .navigation{
            padding-top: 0px;
            padding-bottom:15px;
        }

    }
    .show-check-email-message {
        text-align: center;
    }
    .show-check-email-message >>> br {
        display: inline;
    }
    @media screen and (max-width: 767px) {
        .show-check-email-message {
            text-align: left;
        }
        .show-check-email-message >>> br {
            display: none;
        }
    }
</style>
